<div class="bg-white p-4 flex flex-col gap-2 h-full">
    <div class="relative h-[160px] cursor-pointer" (click)="goToLotsForColor()">
        <img *ngIf="imageUrl" class="object-cover" fill [ngSrc]="imageUrl" [alt]="color.colorName ? color.colorName : color.colorCode" (error)="onImageError()">
    </div>
    <div class="flex flex-1 gap-2 flex-wrap">
        <div>
            <p class="m-0 typography-title-s">
                {{colorText}}
            </p>
            <p *ngIf="color.brand" class="m-0 typography-body-m-light">
                {{brandText}}®
            </p>
        </div>
        <div class="flex-1"></div>
        <div *ngIf="color.priceGroup">
            <span class="typography-body-s-light text-text-tertiary">{{'natural_stone.group' | translate}}&nbsp;{{color.priceGroup}}</span>
        </div>
    </div>
    <div class="w-full">
        <app-button
            [gtmLabel]="'natural-color-' + index"
            [secondary]="true"
            [showIcon]="true"
            [isFullWidth]="true"
            size="medium"
            (onClick)="goToLotsForColor()"
        >{{'natural_stone.view_slabs' | translate}}</app-button>
    </div>
</div>